import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import { TbReportSearch } from "react-icons/tb";

function TradingStrategySettings({ tradingStrategy, changeConfig }) {
  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> Select your preferred crypto trading strategies{" "}
          <span>(you can choose multiple)</span>
        </h6>
      </div>

      <div
        className={styles.strategyList}
        style={{ justifyContent: "center" }}
      >
        <span
          className={`${styles.strategyItem} ${
            tradingStrategy?.includes("Time-based AI-assisted")
              ? styles.active
              : ""
          }`}
          onClick={() =>
            changeConfig(
              "selected_trading_strategies",
              "Time-based AI-assisted",
            )
          }
        >
          Time-based AI-assisted (Recommended)
        </span>

        <span
          className={`${styles.strategyItem} ${
            tradingStrategy?.includes("Trend Following") ? styles.active : ""
          }`}
          onClick={() =>
            changeConfig("selected_trading_strategies", "Trend Following")
          }
        >
          Trend Following
        </span>

        <span
          className={`${styles.strategyItem} ${
            tradingStrategy?.includes("Reversal Strategies")
              ? styles.active
              : ""
          }`}
          onClick={() =>
            changeConfig("selected_trading_strategies", "Reversal Strategies")
          }
        >
          Reversal Strategies
        </span>

        <span
          className={`${styles.strategyItem} ${
            tradingStrategy?.includes("Volatility Management")
              ? styles.active
              : ""
          }`}
          onClick={() =>
            changeConfig("selected_trading_strategies", "Volatility Management")
          }
        >
          Volatility Management
        </span>

        <span
          className={`${styles.strategyItem} ${
            tradingStrategy?.includes("All Day Trading") ? styles.active : ""
          }`}
          onClick={() =>
            changeConfig("selected_trading_strategies", "All Day Trading")
          }
        >
          All Day Trading
        </span>

        <span
          className={`${styles.strategyItem} ${
            tradingStrategy?.includes("Momentum Strategies")
              ? styles.active
              : ""
          }`}
          onClick={() =>
            changeConfig("selected_trading_strategies", "Momentum Strategies")
          }
        >
          Momentum Strategies
        </span>

        <span
          className={`${styles.strategyItem} ${
            tradingStrategy?.includes("Breakout Strategies")
              ? styles.active
              : ""
          }`}
          onClick={() =>
            changeConfig("selected_trading_strategies", "Breakout Strategies")
          }
        >
          Breakout Strategies
        </span>
      </div>
    </>
  );
}

export default TradingStrategySettings;
